import InventoryListingFooter from './InventoryListingFooter';
export default InventoryListingFooter;